import { Component } from "react";

export default class ElementWithIcons extends Component {
  getStyle() {
    let backgroundImage = "",
      backgroundPosition = "",
      backgroundRepeat = "";
    if (this.props.leftImage) {
      backgroundImage += 'url("' + this.props.leftImage + '")';
      backgroundPosition += "10px 50%";
      backgroundRepeat += "no-repeat";
    }
    if (this.props.rightImage) {
      if (this.props.leftImage) {
        backgroundImage += ", ";
        backgroundPosition += ", ";
        backgroundRepeat += ", ";
      }
      backgroundImage += 'url("' + this.props.rightImage + '")';
      backgroundPosition += "calc(100% - 10px) 50%";
      backgroundRepeat += "no-repeat";
    }
    return {
      paddingLeft: this.props.paddingLeft || (this.props.leftImage ? "35px" : ""),
      backgroundImage: backgroundImage,
      backgroundRepeat: backgroundRepeat,
      backgroundPosition: backgroundPosition,
      backgroundSize: this.props.backgroundSize || "18px",
      width: this.props.width || "100%",
    };
  }

  render() {
    let element = (
      <input
        type="text"
        id={this.props.id}
        name={this.props.name}
        placeholder={this.props.placeholder}
        ref={this.props.refProp}
        onChange={this.props.onChange}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        value={this.props.value}
        disabled={this.props.disabled}
        className={this.props.className}
        style={this.getStyle()}
      />
    );
    if (this.props.type && this.props.type === "select") {
      element = (
        <select
          id={this.props.id}
          name={this.props.name}
          onChange={this.props.onChange}
          onBlur={this.props.onBlur}
          value={this.props.value}
          disabled={this.props.disabled}
          className={this.props.className}
          style={this.getStyle()}
        >
          {this.props.children}
        </select>
      );
    }

    return element;
  }
}
